import React, { ReactElement, useEffect, useState } from "react";
import { useAppDispatch } from "redux/hooks";
import { useHistory } from "react-router-dom";
import { Box, Grid, Button } from "@mui/material";
import { Translate } from "react-redux-i18n";

import UserInformation from "components/wallet/UserInformation";
import { PayloadData } from "redux/wallet/walletSlice";
import { closeDialog } from "redux/dialog/dialogSlice";
import { registerRequested } from "redux/auth/authSlice";
import styles from "./styles.module.scss";

interface IProps {
  handleRightDrawer?: () => void;
  referral?: number;
  skinLogo?: string
}
export default function RegisterForm({ handleRightDrawer, skinLogo, referral }: IProps): ReactElement {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [change_password, setIsChangePassword] = useState<boolean>(false)
  const [walletData, setWalletData] = useState<PayloadData>({
    wallet: {
      wallet_type_id: undefined,
    },
    user: {
      username: "",
      password: "",
      c_password: "",
      email: "",
      phone: "",
      firstname: "",
      lastname: "",
      password_change: change_password
    }
  });

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    dispatch(
      registerRequested(
        referral ?
          {
            ...walletData["user"],
            referral: referral
          }
          :
          walletData["user"]
      ));
    handleRightDrawer && handleRightDrawer();
    dispatch(closeDialog())
    referral && history.push("/home")
  };
  const handleChange = (name: string, value: string | boolean, group: string) => {
    setWalletData({
      ...walletData,
      [group]: {
        ...walletData[group],
        [name]: value,
      },
    });
  };

  const handleChangePassword = (value: boolean) => {
    setIsChangePassword(value)
  };

  useEffect(() => {
    setWalletData({
      ...walletData,
      ["user"]: {
        ...walletData["user"],
        ["password_change"]: change_password,
      },
    });
  }, [change_password])

  return (
    <form onSubmit={handleSubmit} className={styles.registerForm}>
      <img src={skinLogo} className={styles.skinLogo} />
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          className={styles.item}
        >
          <p>
            <Translate value="userInformation.label" />
          </p>
          <UserInformation
            data={walletData}
            action="register"
            handleChange={handleChange}
            change_password={change_password}
            handleChangePassword={handleChangePassword}
          />
        </Grid>
        < Box className={styles.buttons}>
          <Button variant="contained" color="success" type="submit">
            <Translate value="buttons.register" />
          </Button>
        </Box>
      </Grid>
    </form>
  );
}
